var React = require('react');

function IconWarranty (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m56.66 100.95h-26.78v-79.75h68.24v79.75h-4.09","key":0}),React.createElement("path",{"d":"m40.55 33h46.9","key":1}),React.createElement("path",{"d":"m40.55 43.69h46.9","key":2}),React.createElement("path",{"d":"m40.55 54.38h46.9","key":3}),React.createElement("path",{"d":"m40.55 65.38h18","key":4}),React.createElement("circle",{"cx":"75.45","cy":"83.08","r":"14","key":5}),React.createElement("path",{"d":"m69.05 84.63 4.64 4.64 8.68-10.38","key":6}),React.createElement("path",{"d":"m86.03 101v13.8l-10.69-6.9-10.68 6.9v-13.8","key":7})]);
}

IconWarranty.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconWarranty;

IconWarranty.default = IconWarranty;
